import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';

const baseConfig: Partial<RumInitConfiguration> = {
  site: 'datadoghq.eu',
  service: 'fulfillment-tools',
  version: __VERSION_HASH__,
  sessionReplaySampleRate: 0,
  trackUserInteractions: true,
  defaultPrivacyLevel: 'allow' as const,
  propagateTraceBaggage: false,
};

if (import.meta.env.VITE_APP_ENV === 'production' && process.env.NODE_ENV === 'production') {
  datadogRum.init({
    ...baseConfig,
    applicationId: '16f00184-a88f-4e53-92a7-4cb2d95d86b6',
    clientToken: 'pub25af68060b0b3b1c4bc58c3016aa404d',
    allowedTracingUrls: [/https:\/\/(?!asset-repository-service\.)[^.]+\.wolt\.com/],
  });
}

if (import.meta.env.VITE_APP_ENV === 'development' && process.env.NODE_ENV === 'production') {
  datadogRum.init({
    ...baseConfig,
    applicationId: '9b5966f1-60e4-40ed-8325-5821a930c577',
    clientToken: 'pub43268fa16946b59a266159243f0d0822',
    allowedTracingUrls: [
      /https:\/\/(?!asset-repository-service\.)[^.]+\.development\.dev\.woltapi\.com/,
    ],
  });
}
